import { useCallback, useMemo } from 'react'
import { useLingui } from '@lingui/react/macro'
import { GraphQL } from '@guestgoodie/graphql'

import MultiComboBox from '@/components/ui/MultiComboBox'
import { useBanners } from '../hooks/useBanners'

export interface Props {
  value?: GraphQL.BannerFragmentFragment[] | null
  placeholder?: string
  onChange: (ids: GraphQL.BannerFragmentFragment[] | null) => void
  name?: string
  invalid?: boolean
  readOnly?: boolean
}

export default function SelectBanners({
  value,
  placeholder,
  onChange,
  name,
  invalid = false,
  readOnly = false
}: Props) {
  const { t } = useLingui()

  const banners = useBanners()

  const idToBanner = useMemo(() => {
    return Object.fromEntries(banners?.map(b => [b.id, b]) ?? [])
  }, [banners])

  const items = useMemo(() => {
    return (
      banners?.map(function (banner) {
        return {
          value: banner.id,
          label: banner.name
        }
      }) ?? []
    )
  }, [banners])

  const selectedIds = useMemo(() => value?.map(b => b.id), [value])

  const onChangeProxy = useCallback(
    (ids: number[]) => {
      const items = ids.map(id => idToBanner[id])

      onChange(items)
    },
    [idToBanner, onChange]
  )

  return (
    <MultiComboBox<number>
      value={selectedIds ?? []}
      onChange={onChangeProxy}
      options={items}
      invalid={invalid}
      placeholder={placeholder}
      name={name}
      searchText={t`Search Banners`}
      readOnly={readOnly}
    />
  )
}
